import config from '../config';

class UserApiService {
  getAccessToken() {
    return localStorage.getItem(config.accessTokenKey);
  }

  getRefreshToken() {
    return localStorage.getItem(config.refreshTokenKey);
  }

  setTokens(accessToken, refreshToken) {
    if (accessToken) localStorage.setItem(config.accessTokenKey, accessToken);
    if (refreshToken) localStorage.setItem(config.refreshTokenKey, refreshToken);
  }

  clearTokens() {
    localStorage.removeItem(config.accessTokenKey);
    localStorage.removeItem(config.refreshTokenKey);
  }

  async refreshAccessToken() {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) return null;

    const response = await fetch(`${config.backendBaseUrl}/api/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    });

    if (!response.ok) {
      this.clearTokens();
      return null;
    }

    const data = await response.json();
    this.setTokens(data.accessToken, data.refreshToken);
    return data.accessToken;
  }

  async request(endpoint, options = {}) {
    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    };

    const token = this.getAccessToken();
    if (token) headers.Authorization = `Bearer ${token}`;

    let response = await fetch(`${config.backendBaseUrl}${endpoint}`, {
      ...options,
      headers,
    });

    if (response.status === 401 && this.getRefreshToken()) {
      const newToken = await this.refreshAccessToken();
      if (newToken) {
        headers.Authorization = `Bearer ${newToken}`;
        response = await fetch(`${config.backendBaseUrl}${endpoint}`, {
          ...options,
          headers,
        });
      }
    }

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data?.error?.message || data?.message || `Request failed: ${response.status}`);
    }

    return data;
  }

  async login(username, password) {
    return this.request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  }

  async signup(username, password) {
    return this.request('/api/auth/register/batman', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  }

  async getAccount() {
    return this.request('/api/account', { method: 'GET' });
  }

  async createPaymentOrder(payload) {
    return this.request('/api/payment/create-order', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async verifyPayment(payload) {
    return this.request('/api/payment/verify-payment', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async getPaymentConfig() {
    return this.request('/api/payment/config', { method: 'GET' });
  }
}

const userApi = new UserApiService();
export default userApi;
